// extracted by mini-css-extract-plugin
export var infoRow = "_kc-2";
export var labelContainer = "_kc-0";
export var rightInfo = "_kc-1";